import { privateClient } from './client';

const requestSubscription = (sessionId, card, cvv, plan, cpfVendedor) => privateClient(sessionId).post('/v1/subscription/', { card, cvv, plan, cpfVendedor });

const requestSubscriptionV2 = (sessionId, card, cvv, plan, cpf, data3ds, headers) => privateClient(sessionId).post('/v2/subscription/', { card, cvv, plan, cpf, data3ds }, headers);

export { requestSubscription, requestSubscriptionV2 };
